export const ZoneGetters = {
  GET_COLOR_DATA: 'getZoneColorData'
};
